<script>
import chevronIcon from '@/assets/images/icons/chevron.svg?inline'
import {
  rexText
} from '@/components/views/rexField'

export default {
  name: 'documents',
  components: {
    chevronIcon,
    rexText
  },
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    orderId: {
      type: String,
      default: () => null
    },
  },
  computed: {
    loadingState() {
      return this.$store.getters['order/getDocumentsFormLoading']
    },
    bookingId: {
      get() {
        return this.$store.getters['order/getServiceField']('documentsForm.bookingId')
      },
      set(value) {
        this.$store.commit('order/updateServiceField', {
          target: 'documentsForm.bookingId',
          value
        })
      }
    },
    email() {
      return this.$store.getters['order/getServiceField']('documentsForm.email')
    }
  },
  methods: {
    toggle(bookingId) {
      this.bookingId = this.bookingId === bookingId
        ? null
        : bookingId
    },
    send({ bookingId, name }) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('order/updateDocumentsLoading', {
            isSending: true
          })

          this.$store.dispatch('order/sendDocument', {
            bookingId,
            name,
            email: this.email
          })
        }
      })
    },
    download({ bookingId, name }) {
      this.$store.commit('order/updateDocumentsLoading', {
        isDownloading: true
      })

      this.$store.dispatch('order/downloadDocument', {
        bookingId,
        name: `${name.replace(' ', '_')}_${this.orderId}`
      })
    },
    downloadAll() {
      this.$store.commit('order/updateDocumentsLoading', {
        isDownloadingAll: true
      })

      this.$store.dispatch('order/downloadAllDocuments', this.orderId)
    }
  }
}
</script>

<template>
  <div class="order-documents">
    <div v-if="documents.length">
      <div
        class="order-documents__list"
      >
        <div
          v-for="(document, index) in documents"
          :key="index"
          class="order-documents__list-item"
        >
          <div
            class="order-documents__list-item-header"
            @click="toggle(document.bookingId)"
          >
            {{ document.name }}
            <chevron-icon
              class="order-documents__list-item-header-icon"
              fill="#ababab"
            />
          </div>
          <div
            v-if="bookingId === document.bookingId"
            class="order-documents__list-item-content"
          >
            <rex-text
              name="documentsFormEmail"
              store-module="order"
              getter-name="getServiceField"
              setter-name="updateServiceField"
              target="documentsForm.email"
              :validate="{
                required: true,
                email: true
              }"
              :disabled="loadingState.isSending"
              placeholder="Укажите свой email"
            />
            <div class="order-documents__list-item-actions">
              <a
                href="javascript:;"
                class="order-documents__link"
                :class="{
                  'order-documents__link--loading': loadingState.isDownloading
                }"
                @click="download(document)"
              >
                <b-loading
                  :is-full-page="false"
                  :active="loadingState.isDownloading"
                />
                Скачать
              </a>
              <button
                class="rex-button rex-button--filled rex-button--filled-red"
                :class="{
                  'rex-button--disabled rex-button--hide-text': loadingState.isSending
                }"
                :disabled="loadingState.isSending"
                @click="send(document)"
              >
                <b-loading
                  :is-full-page="false"
                  :active="loadingState.isSending"
                />
                Отправить
              </button>
            </div>
          </div>
        </div>
      </div>
      <a
        href="javascript:;"
        class="order-documents__download-archive order-documents__link"
        :class="{
          'order-documents__link--loading': loadingState.isDownloadingAll
        }"
        @click="downloadAll"
      >
        <b-loading
          :is-full-page="false"
          :active="loadingState.isDownloadingAll"
        />
        Скачать все документы одним файлом
      </a>
    </div>
    <p v-else>
      Нет документов, доступных для скачивания или отправки на электронную почту
    </p>
  </div>
</template>
